const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const LcwMoneyQuery: any = {
    GetWallet: Backofficebff + '/v1/lcwmoney/getwallet',
    GetCustomerIdWithEmail: Backofficebff + '/v1/customer/GetByEmail',
};
